<template>
  <div style="max-height: 1920px;">

    <v-row>
      <v-col cols="12" md="12" style="text-align: center;">
        <v-row>
          <v-col cols="12" md="12" style="text-align: center;">
            <v-img alt="Logo" class="shrink mr-2 app" contain :src="logoimage" transition="scale-transition"
              width="1000" />
          </v-col>
        </v-row>
        <v-sheet class="folded-corner" width="1045" height="1100" style="margin-top: 250px">
          <v-container>
            <v-row>
              <v-card elevation="0" width="900" height="1100" style="
                  background-color: white;
                " class="align-center pa-4 mx-auto">
                <v-row style="margin-top: 3%">
                  <!-- <v-col cols="12" md="12" style="
                      text-align: center;
                      font-size: 60px;
                      color: #344054;
                    ">

                    {{ $t("message.PleaselookCamera") }}
                  </v-col> -->
                  <v-col cols="12" md="12" style="text-align: center;">
                    <span style="color: #344054;font-size: 60px;font-weight: 800;">
                      {{ "กรุณามองกล้อง" }}
                    </span>
                    <br>
                    <span style="color: #898A8C;font-size: 40px;font-weight: 700;">{{ "PLEASE LOOK AT THE CAMERA"
                      }}</span>
                  </v-col>
                </v-row>
                <v-row style="display: flex;justify-content: center;">
                  <v-col cols="7" md="7">

                    <v-divider style="border-top-width: 8px !important;border-color: #344054; "></v-divider>
                  </v-col>
                </v-row>
                <!-- <v-row style="    display: flex;
    justify-content: flex-end;padding-right: 40px;">
                  <v-progress-circular color="#344054" indeterminate size="100 ">
                    <span style="font-size: 40px;">{{ timerCount }}</span>
                  </v-progress-circular>
                </v-row> -->
                <v-row style="margin-top: 5%">
                  <v-col cols="12" md="12" style="display: flex;justify-content: center;">
                    <div class="camera-container">
                      <video v-show="!isPhotoTaken" ref="camera" style="width: 100%;height: 480px;" autoplay></video>
                       <div class="overlay-corner"><div></div></div>
                      <!-- <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" ></canvas> -->
                        <!-- <img v-if="isPhotoTaken" :src="photoBase64" alt="Captured photo" style="height: 480px;" /> -->
                    </div>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 10%">
                  <v-col cols="6" md="6" style="display: flex;justify-content: center;">
                    <!-- <v-btn color="#344054" class="box white--text mt-2 text-capitalize" router width="500"
                      style="font-size: 45px; " height="100" @click="BacktoNationalIDCard()">{{
                        $t("message.Back") }}</v-btn> -->
                    <v-card elevation="0" class="box white--text mt-2 text-capitalize" color="#344054"
                      @click="BackToMain()" style="line-height:1.1" height="110">
                      <span style="font-size: 45px;"> {{ "ย้อนกลับ" }}</span>
                      <br>
                      <span style="font-size: 25px;"> {{ "BACK" }}</span>
                    </v-card>
                  </v-col>
                  <v-col cols="6" md="6" style="display: flex;justify-content: center;">
                    <!-- <v-btn color="#344054" class="box white--text mt-2 text-capitalize" router id="downloadPhoto"
                      :download="PictureName" width="500" style="font-size: 45px;" height="100" @click="takePhoto">
                      <span style="font-size: 45px;"> {{ "รับ QR CODE เข้าอาคาร" }}</span>
                      <br>
                      <span style="font-size: 25px;"> {{ "GET ENTRY QR CODE" }}</span>
                    </v-btn> -->

                    <v-card id="downloadPhoto" elevation="0" class="box white--text mt-2 text-capitalize"
                      color="#344054" :download="PictureName" @click="takePhotobast64()" style="line-height:1.1" height="110">
                      <span style="font-size: 45px;"> {{ "ถ่ายรูป" }}</span>
                      <br>
                      <span style="font-size: 25px;"> {{ "TAKE A PHOTO" }}</span>
                    </v-card>
                  </v-col>

                </v-row>
              </v-card>
            </v-row>

          </v-container>
        </v-sheet>
      </v-col>
    </v-row>

  </div>
</template>
<script>
// import axios from "axios";
import enurl from "@/api/environment";
// import logoimage from "@/assets/OneBangkokLogo.png";
// import ChangeLanguage from "@/components/ChangeLanguage";
export default {
  name: "CapturePerson",
  components: {
    // ChangeLanguage,
  },
  data() {
    return {
      url: enurl.apiUrl,
      settingUrl: enurl.settingUrl,
      DefaultLogo: "@/assets/logo192.png",
      DefaultBG: "@/assets/1D2939.png",
      Datetime: "",
      timerCount: 30,
      isPhotoTaken: false,
      download: false,
      PictureName: "PersonID.jpg",
      dataParam: [],
      imageParam: "",
      photoBase64: "",
      logoimage: "",
    };
  },

  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
            // if (this.timerCount % 3 == 0) {
            //   this.getDataPersonWithThaiSmartCard();
            // }
            // if (this.timerCount == 25) {
            //   this.skip();
            // }
            if (this.timerCount == 0) {
              this.BackToMain();
            }
          }, 1000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },

  mounted: function () {
    let self = this;
    self.createCameraElement();

   
    self.dataParam = self.$route.params.data;
    self.logoimage = require("@/assets/OneBangkokLogo.png");
    //  console.log(self.dataParam);

    // setInterval(() => {
    //   self.getCurrentDate();
    // }, 1000);
  },

  methods: {
    getCurrentDate() {
      let self = this;
      let newDate = new Date();
      let date =
        newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
      let month = newDate.getMonth() + 1;
      let year =
        newDate.getFullYear() < 2500
          ? newDate.getFullYear() + 543
          : newDate.getFullYear();
      let hours =
        newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours();
      let minutes =
        newDate.getMinutes() < 10
          ? "0" + newDate.getMinutes()
          : newDate.getMinutes();
      let seconds =
        newDate.getSeconds() < 10
          ? "0" + newDate.getSeconds()
          : newDate.getSeconds();
      self.Datetime = `${date}/${month < 10 ? `0${month}` : `${month}`
        }/${year}  ${hours}:${minutes}:${seconds}`;
    },

    createCameraElement() {
      const constraints = (window.constraints = {
        audio: false,
        video: true,
      });

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.$refs.camera.srcObject = stream;
          const track = stream.getVideoTracks()[0];

          this.imageCapture = new ImageCapture(track);
          console.log(this.imageCapture);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    stopCameraStream() {

      if (this.$refs.camera.srcObject != null) {
        let tracks = this.$refs.camera.srcObject.getTracks();
        tracks.forEach((track) => {
          track.stop();
        });
      }


    },

      takePhoto() {
      let self = this;
      self.isShotPhoto = true;
      self.LoadingDialog = true;
      const FLASH_TIMEOUT = 50;


      const videoElement = self.$refs.camera;
      const canvasElement = self.$refs.canvas;
      const context = canvasElement.getContext("2d");

      canvasElement.width = videoElement.videoWidth;
      canvasElement.height = videoElement.videoHeight;
      context.drawImage(
        videoElement,
        -180, -650,
        1080,
        1980
      );

      setTimeout(() => {
        self.isShotPhoto = false;
        self.GotoFindingTenant();
        // this.downloadImage();
      }, FLASH_TIMEOUT);

    },

     async takePhotobast64() {
      let self = this;
      self.LoadingDialog = true;
      const blob = await this.imageCapture.takePhoto();
      // photo.value = URL.createObjectURL(blob);
      const base64 = await this.cropAndConvertToBase64(blob,900,900);


      this.isPhotoTaken = true;
      this.photoBase64 = base64;
      this.dataParam.image2 = base64.split(",")[1];
      // this.ocr();

      setTimeout(() => {
        self.isShotPhoto = false;
        self.GotoFindingTenant();
        // this.downloadImage();
      }, 1000);
      // console.log(blob);
    },

      async cropAndConvertToBase64(blob, cropTop = 0, cropBottom = 0) {
      const imageBitmap = await createImageBitmap(blob);
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // คำนวณขนาดภาพที่เหลือหลังตัด
      const cropHeight = imageBitmap.height - cropTop - cropBottom;

      // ตั้งขนาด canvas ใหม่
      canvas.width = imageBitmap.width;
      canvas.height = cropHeight;

      // วาดภาพเฉพาะส่วนที่ต้องการ (เริ่มจาก cropTop ลงมา)
      ctx.drawImage(
        imageBitmap,
        0, cropTop, imageBitmap.width, cropHeight, // ส่วนที่ตัดจากต้นฉบับ
        0, 0, imageBitmap.width, cropHeight        // วาดลงบน canvas
      );

      // แปลง canvas → base64
      return canvas.toDataURL("image/jpeg", 0.8); // 0.9 = คุณภาพ
    },
   

    downloadImage() {
      const canvas = document
        .getElementById("photoTaken")
        .toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");
      // console.log(canvas);
      this.imageParam = canvas;
      this.dataParam.image2 = this.imageParam.split(",")[1];
    },

    GotoFindingTenant() {
      let self = this;
      // self.downloadImage();
      // self.stopCameraStream();
      // self.$router.push("/FindingTenant");
      self.$router.push({
        name: "FindingTenant",
        path: "/FindingTenant",
        params: {
          data: self.dataParam,
        },
      });

    },

    BackToMain() {
      let self = this;
      self.$router.push("/MainMenu");
    },

    BacktoNationalIDCard() {
      let self = this;
      self.stopCameraStream();
      self.$router.push("/NationalIDCard");
    },

    CapturePerson() {
      let self = this;
      self.$router.push("/CapturePerson");
    },
  },
};
</script>
<style scoped>
@media all and (orientation: portrait) {
  .fullscreen {
    height: 1890px;
  }
}

@media all and (orientation: landscape) {
  .fullscreen {
    height: auto;
  }
}

.camera-container {
  position: relative;
  width: 640px;
  height: 480px;
}

video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

</style>